﻿"use strict";

$(document).ready(function () {
	$('#sidebarCollapseButton').on('click', function () {
		try {
			var wrapper = $('.sidebar-wrapper');
			var newClass = '';

			if (wrapper.hasClass('full-collapsed-sidebar')) { // Full to collapsed
				newClass = 'collapsed-sidebar';
			} else if (wrapper.hasClass('collapsed-sidebar')) { // Collapsed to normal

			} else { // Normal to collapsed
				newClass = 'collapsed-sidebar';
			}

			wrapper.removeClass('full-collapsed-sidebar');
			wrapper.removeClass('collapsed-sidebar');
			if (newClass) {
				wrapper.addClass(newClass);
			}

			// Do not save anything on mobile
			if (window.matchMedia('(min-width: 768px)').matches) {
				setCookieValue('AppSettings', 'SidebarState', newClass);
			} else {
				setCookieValue('AppSettings', 'SidebarState', null);
			}
		} catch (e) {
			console.log(e);
		}
	});

	$('#sidebarFullCollapseButton').on('click', function () {
		try {
			var wrapper = $('.sidebar-wrapper');
			var newClass = '';

			if (wrapper.hasClass('full-collapsed-sidebar')) {	// Full to normal

			} else if (wrapper.hasClass('collapsed-sidebar')) {	// Collapsed to full
				newClass = 'full-collapsed-sidebar';
			} else {	// Normal to full
				newClass = 'full-collapsed-sidebar';
			}

			wrapper.removeClass('full-collapsed-sidebar');
			wrapper.removeClass('collapsed-sidebar');
			if (newClass) {
				wrapper.addClass(newClass);
			}
			// Do not save anything on mobile
			if (window.matchMedia('(min-width: 768px)').matches) {
				setCookieValue('AppSettings', 'SidebarState', newClass);
			} else {
				setCookieValue('AppSettings', 'SidebarState', null);
			}
		} catch (e) {
			console.log(e);
		}
	});
});

window.stripQueryParamsAndTrailingSlash = function(url) {
	if (url) {
		url = url.split(/[?#]/)[0];	// Remove query parameters and hash addresses
		if (url.substr(-1) == '/') {
			return url.substr(0, url.length - 1);
		}
	}
	return url;
}

/* Sets the active class to the active sidebar nav element */
window.setActiveSidebarElement = function () {
	try {

		var url = window.location.pathname;
		var activePage = stripQueryParamsAndTrailingSlash(url);

		var activePageLink$ = $(`#sidebar li > a[href='${url}']`);
		var activePageLevel = activePageLink$ ? activePageLink$.parentsUntil('#sidebar', 'li').length : 0;
		$('#sidebar li > a').each(function () {
			try {
				var page = stripQueryParamsAndTrailingSlash($(this).attr('href'));
				if (!page)
					page = '@#$@%^@&';	// Random that will never match

				// Do not highlight any pages (except the active one) at the same level in the sidebar
				var pageLevel = $(this).parentsUntil('#sidebar', 'li').length;
				if (pageLevel == activePageLevel && activePage != page)
					return true;	// Exit the jquery each function but continue with the next (= continue); return false would be = break

				var alternativePagesStr = stripQueryParamsAndTrailingSlash($(this).attr('data-prefix-for-active'));
				var alternativePagesArr = [];
				if (alternativePagesStr)
					alternativePagesArr = alternativePagesStr.split(',');

				if (activePage == page || alternativePagesArr.some(alternativePage => activePage == alternativePage) || (
					((activePage.startsWith(page + '/') || alternativePagesArr.some(alternativePage => activePage.startsWith(alternativePage + '/'))) && !activePage.includes('endorsements/licenseview') /* Otherwise at license view both endorsements and license view are highlighted at the same time */) &&
					// Special cases for controllers with default actions
					// Do not match the settings default page for any controllers in the settings subarea, but match specific settings pages to the settings main page
					(!page.endsWith('settings') || activePage.includes('settings/settings/')) &&
					!page.endsWith('about') &&
					(!page.endsWith('useraccount') || activePage.includes('useraccount/emails/') || activePage.includes('useraccount/manageaccount/'))
				)) {
					var isDeepestLevel = true;

					var current = $(this).parent();
					while (current.attr('id') != 'sidebar') {
						if (current.is('li')) {
							if (isDeepestLevel)
								current.addClass('active');
							else
								current.addClass('main-active');
							isDeepestLevel = false;
						}
						else if (current.hasClass('collapse')) {	// Open the parent of the element if any
							current
								.on('shown.bs.collapse', function () {
									$(this).removeClass('no-transition');	// Reenable transitions
								})
								.addClass('no-transition')					// Disable transitions for this operation
								.collapse('show');
						}
						current = current.parent();
					}
				}
			} catch (e) {
				console.log(e);
			}
		});
	} catch (e) {
		console.log(e);
	}
}